<div
  class="tooltip-content"
  role="tooltip"
  [id]="id"
  [style.max-width]="maxWidth()"
  [@fadeInOnEnter]="animationName()"
  [@fadeOutOnLeave]="leaveAnimationName()">
  @if (!isTemplate()) {
    @if (displayContent() !== null) {
      <div>{{ displayContent() }}</div>
    }
    @if (displayContent() === null) {
      <ng-content></ng-content>
    }
  }
  @if (isTemplate()) {
    <ng-container [ngTemplateOutlet]="displayTemplate()"></ng-container>
  }
</div>
